import { useEffect } from 'react';

import store from 'store';

import useId from '@common/helpers/useId';
import useModel from '@common/helpers/useModel';
import StudentProgramModel, {
	IStudentProgramModel,
} from '@common/models/StudentPrograms/StudentProgram';

export default () => {
	const { programId, groupId, programGroupId } = useId(['programId', 'groupId', 'programGroupId']);

	const programModel = useModel(
		StudentProgramModel,
		{
			program_id: programId,
			group_id: groupId,
			program_group_id: programGroupId,
		},
		[programId, groupId, programGroupId],
		{
			disableFetch: true,
		},
	) as IStudentProgramModel;

	useEffect(() => {
		if (programGroupId) {
			programModel.fetch({
				student_id: store.currentStudentId,
				service_id: store.services.current.id,
			});
		} else {
			programModel.fetchIndiv({
				student_id: store.currentStudentId,
				service_id: store.services.current.id,
			});
		}
	}, [programId, groupId, programGroupId, store.services.current.id, store.currentStudentId]);

	return { programModel };
};
